module.exports = __webpack_public_path__ + "static/media/Career_Coach_Online.cff5278a.png";